import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Decode keeps session and preference state in Web Storage, and the providers
// read it while rendering, so a browser that denies it would blank the page
// with no explanation. Probe both stores first; a denial gets a plain screen
// (no theme, no providers — nothing that touches storage).
const storageAvailable = (name) => {
  try {
    const store = window[name];
    const key = '__decode_storage_probe__';
    store.setItem(key, '1');
    store.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
};

function StorageBlocked() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24, fontFamily: 'Roboto, Helvetica, Arial, sans-serif', textAlign: 'center', color: '#1f2933',
    }}>
      <div style={{ maxWidth: 520 }}>
        <div style={{ fontSize: 22, fontWeight: 500, marginBottom: 12 }}>Decode cannot start in this browser</div>
        <div style={{ fontSize: 15, lineHeight: 1.5 }}>
          Decode requires access to your browser&apos;s local and session storage. Please speak to your IT team.
        </div>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {storageAvailable('localStorage') && storageAvailable('sessionStorage') ? <App /> : <StorageBlocked />}
  </React.StrictMode>
);

reportWebVitals();